import { render, staticRenderFns } from "./DynamicPriceModal.vue?vue&type=template&id=4b4ee4c1&scoped=true&"
import script from "./DynamicPriceModal.vue?vue&type=script&lang=js&"
export * from "./DynamicPriceModal.vue?vue&type=script&lang=js&"
import style0 from "./DynamicPriceModal.vue?vue&type=style&index=0&id=4b4ee4c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4ee4c1",
  null
  
)

export default component.exports